import { createFileRoute } from '@tanstack/react-router'
import { Instances } from '@/features/instances'

export const Route = createFileRoute('/_authenticated/instances/')({
  component: Instances,
})
